import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"
import styles from "./MusicLicensingContainer.module.scss"

const MusicLicensingContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section
      id="mm-music-licensing"
      className={cx("pageContainer", styles.musicLicensing)}
      aria-label="Music Licensing page"
    >
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default MusicLicensingContainer
